import React, {useContext} from 'react';
import { useHistory } from "react-router-dom";
import {Flex, Box} from 'reflexbox';
import {observer} from 'mobx-react-lite/dist/index';
import { Heading } from '@book/pattern-library-framework';

import {StoreContext} from '../../helpers/StoreContext'
import PhoneSvg from './PhoneSvg';
import {mapHotlinePhone} from '../../helpers/helpers'

import "./Form.scss";

// Booking Code: 56e02b07-7472-49be-a77d-20d725130a8a

const Greetings = observer( () => {
    const stores = useContext(StoreContext);
    const displayStore = stores.displayStore;
    const fullName = displayStore.userFullName.get();

    if (fullName !== undefined && fullName !== '') {
        return (
          <p className='text'>
              Hallo <strong>{fullName}</strong>,<br/>
              wir freuen uns, dass du dich von unseren Mitarbeitern zu deinen Urlaubswünschen beraten lässt. Deine persönliche Beratungsnummer gilt
              nur für die für dich persönlich erstellten Angebote. Bei Fragen zu den Angeboten auf dieser Seite gib unseren Kollegen einfach deine Beratungsnummer an.
          </p>
        );
    }else{
        return (
          <p className='text'>
              Hallo,<br/>
              bitte trage deine persönliche Beratungsnummer in das dafür vorgesehene Feld ein, um die von unseren Beratern für dich erstellten Angebote zu sehen.
          </p>
        );
    }
});

export default observer( () => {
  // vorbereitender Teil
    const stores = useContext(StoreContext);
    const displayStore = stores.displayStore;
    const history = useHistory();

    const loadHotels = async (value) => {
      stores.guidanceCode = value;
      displayStore.errorLoadingCode.set(false);
      if (value === ''){
        stores.hotelStore.setHotels([]);
        stores.displayStore.clearHotelList();
        displayStore.showHotelList.set(false);
        document.getElementById('offerFormButton').innerText = "Anzeigen";
      }else{
        displayStore.isLoading.set(true);
        if (!await stores.hotelStore.fetch(stores.guidanceCode)){
          displayStore.errorLoadingCode.set(true);
        //displayStore.isLoading.set(false);
        }
      }
    };
    const hotelStore = stores.hotelStore;
    const hasHotels = hotelStore.hasHotels;
    const guidanceBoxClass = 'guidanceCode' + (hasHotels ? ' valid' : '');
    const loadingError = displayStore.errorLoadingCode.get() ? (<div className="container"><div className='introduction__wrapper'><div className="error">Fehler beim Laden</div></div></div>) : (null);
    const desktopPhoneLink = document.querySelector('#header > div.hotline-wrapper.bookmark-pos > a');
    const mobilePhoneLink = document.querySelector('#navigation-head-sub > ul > li.item-phone > a');
    
    const onChangeHandler = (e) => {
        let value = e.target.value.trim();
        stores.setGuidanceCode(value);
        history.replace(value);
        if (hasHotels === true) {
            stores.displayStore.clearHotelList();
        }
    };

    const onKeyDownHandler = (e) => {
        if (e.key === 'Enter' || e.key === " ") {
            let guidanceCode = stores.guidanceCode.trim();
            loadHotels(guidanceCode);
            history.replace(guidanceCode);
        }
    };

    if (hotelStore.department !== undefined) {
      const phone = mapHotlinePhone[hotelStore.department] ? mapHotlinePhone[hotelStore.department] : "0341 65050 51060";

      if(hotelStore.numHotels > 0 && desktopPhoneLink ) {
        desktopPhoneLink.setAttribute('href', `tel:${phone}`);
        desktopPhoneLink.innerHTML = `${phone}`;
      }
      if(hotelStore.numHotels > 0 && mobilePhoneLink ) {
        mobilePhoneLink.setAttribute('href', `tel:${phone}`);
        mobilePhoneLink.innerHTML = `${phone}`;
      } 
    } 
    

    const onClickHandler = (e) =>  {
        let guidanceCode = stores.guidanceCode.trim();
        if (hasHotels) {
            loadHotels('');
        }else{
            loadHotels(guidanceCode);
        }
        history.replace(guidanceCode);
    };

    // darstellender Teil
    return (<div className="form">
              <div className='container '>
                <div className='introduction__wrapper'>
                    <div>
                      <Heading type='h1'>Willkommen zu Deiner persönlichen Liveberatung</Heading>
                      <Greetings/>
                    </div>

                    <Flex className="form-input" flexDirection="row">
                      <Box width={[1, 1, 1, 2/3]}  className="intro-left">
                        <Flex>
                          <Box width={[1, 1, 0.5]} className={guidanceBoxClass}>
                              <input placeholder="Deine Beratungsnummer" value={stores.guidanceCode.trim()} onChange={onChangeHandler} onKeyDown={onKeyDownHandler}/>
                              <PhoneSvg/>
                          </Box>
                          <Box width={[1, 1, 0.5]}>
                            <button id="offerFormButton"
                                    className={(hasHotels ? ' blue' : '')} 
                                    disabled={stores.guidanceCode.trim() === ''}
                                    onClick={onClickHandler}
                            >{hasHotels ? "Zurück" : (displayStore.isLoading.get() ? 'Lade...' : 'Anzeigen')}</button>
                          </Box>
                        </Flex>
                      </Box>
                      {hotelStore.numHotels > 0 && hotelStore.department !== undefined && (
                        <Box width={[1, 1, 1, 1/3]}  className="intro-right">
                          <Flex>
                            <Box width={[1,0.25]}>
                              <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M35.9319 32.9101L30.1507 38.6084L15.3905 23.8449L21.0875 18.0624C21.7922 17.3454 21.9938 16.2736 21.5978 15.3495L15.6655 1.50016C15.1808 0.371375 13.9423 -0.231669 12.7551 0.0830243L1.85651 2.9619C0.73494 3.25216 -0.035662 4.28124 0.00127247 5.43941C0.694417 18.1092 5.96115 30.0967 14.8233 39.1758C23.9032 48.0412 35.8919 53.3085 48.5618 53.9987C49.7197 54.0357 50.7486 53.2649 51.0388 52.1431L53.917 41.242C54.2316 40.0545 53.6287 38.8157 52.5002 38.3309L38.654 32.3973C37.727 31.9973 36.65 32.2002 35.9319 32.9101Z" fill="white"/>
                              </svg>
                            </Box>
                            <Box width={[1,0.75]}>
                              <p>Dein Beratungsteam erreichst<br/>du unter der Nummer</p>
                              <p className="phonenumber">{mapHotlinePhone[hotelStore.department] ? mapHotlinePhone[hotelStore.department] : "0341 65050 51060"}</p>
                            </Box>
                          </Flex>
                        </Box>
                      )}
                    </Flex>
                </div>
              </div>
              {loadingError}
            </div>);
});
